import { Component, OnInit, ViewChild } from '@angular/core';
import {
  InvoicedetailService,
  InvoiceDetailsModel,
  MarkAsPaidModal,
} from './invoicedetail.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService, BillingInfoModel } from '../users/users.service';
import { Location } from '@angular/common';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { ToastService } from '../../../toast.service';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

import { TDocumentDefinitions, TDocumentInformation } from 'pdfmake/interfaces';
import { style } from '@angular/animations';
// Set the VFS for pdfMake
// (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

import {
  AlertModule,
  BadgeModule,
  ButtonModule,
  CardModule,
  CollapseModule,
  GridModule,
  SharedModule,
  SmartTableModule,
  TableModule,
  UtilitiesModule,
  ModalModule,
  FormModule,
  ProgressModule,
  SpinnerModule,
  NavModule,
  TabsModule,
  ButtonGroupModule,
  DropdownModule,
  ListGroupModule,
  MultiSelectModule,
  DatePickerModule,
  DateRangePickerModule,
  TimePickerModule,
  LoadingButtonModule,
  CalloutModule,
  ImgModule,
  PopoverModule,
  OffcanvasModule,
  AvatarModule,
  Tabs2Module,
  ToasterComponent,
  ToasterPlacement,
} from '@coreui/angular-pro';
import { IconModule, IconSetService } from '@coreui/icons-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppToastComponent } from '../../notifications/toasters/toast-simple/toast.component';
import { set } from 'lodash-es';
import { delay } from 'rxjs';

@Component({
  selector: 'app-invoicedetail',
  templateUrl: './invoicedetail.component.html',
  standalone: true,
  imports: [
    GridModule,
    CardModule,
    SmartTableModule,
    CollapseModule,
    TableModule,
    UtilitiesModule,
    BadgeModule,
    SharedModule,
    ButtonModule,
    AlertModule,
    HttpClientModule,
    ModalModule,
    FormModule,
    FormsModule,
    ReactiveFormsModule,
    IconModule,
    ProgressModule,
    SpinnerModule,
    NavModule,
    CardModule,
    GridModule,
    TabsModule,
    ButtonGroupModule,
    ButtonModule,
    CardModule,
    DropdownModule,
    FormModule,
    GridModule,
    ListGroupModule,
    MultiSelectModule,
    SharedModule,
    DatePickerModule,
    DateRangePickerModule,
    TimePickerModule,
    IconModule,
    LoadingButtonModule,
    ModalModule,
    TableModule,
    UtilitiesModule,
    AlertModule,
    BadgeModule,
    ButtonModule,
    CardModule,
    CollapseModule,
    GridModule,
    SharedModule,
    SmartTableModule,
    TableModule,
    UtilitiesModule,
    LoadingButtonModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnerModule,
    CalloutModule,
    ImgModule,
    PopoverModule,
    AlertModule,
    OffcanvasModule,
    DatePickerModule,
    DropdownModule,
    SharedModule,
    AvatarModule,
    Tabs2Module,
    MultiSelectModule,
    CommonModule,
    ToasterComponent,
  ],
  styleUrl: './invoicedetail.component.scss',
})
export class InvoicedetailComponent implements OnInit {
  payNowForm: FormGroup;
  fromportal: boolean = false;
  cardType: string | null = null;
  cardTypeIcon: string | null = null;
  constructor(
    public InvoicedetailService: InvoicedetailService,
    public router: Router,
    public UsersService: UsersService,
    public ToastService: ToastService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private location: Location
  ) {
    // Initialize the form group with validation
    this.payNowForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      cardNumber: ['', [Validators.required, Validators.pattern(/^\d{16}$/)]],
      expiryMonth: [
        '',
        [Validators.required, Validators.pattern(/^(0[1-9]|1[0-2])$/)],
      ],
      expiryYear: ['', [Validators.required, Validators.pattern(/^\d{2}$/)]],
      cvv: ['', [Validators.required, Validators.pattern(/^\d{3}$/)]],
      firstNamebilling: [
        { value: '', },
        Validators.required,
      ],
      
      addressLine1: [
        { value: '' },
        Validators.required,
      ],
      
      state: [
        { value: '' },
        Validators.required,
      ],
      city: [
        { value: '' },
        Validators.required,
      ],
      zipCode: [
        { value: '' },
        Validators.required,
      ],
      country: [
        { value: '' },
        Validators.required,
      ],
    });
  }

  onChangedBusinessInformation(event: any) {
    if (event.target.checked) {
      this.payNowForm.controls['firstNamebilling'].enable();
      this.payNowForm.controls['addressLine1'].enable();
      this.payNowForm.controls['state'].enable();
      this.payNowForm.controls['city'].enable();
      this.payNowForm.controls['zipCode'].enable();
      this.payNowForm.controls['country'].enable();
    } else {
      this.payNowForm.controls['firstNamebilling'].disable();
      this.payNowForm.controls['addressLine1'].disable();
      this.payNowForm.controls['state'].disable();
      this.payNowForm.controls['city'].disable();
      this.payNowForm.controls['zipCode'].disable();
      this.payNowForm.controls['country'].disable();
    }
  }
  ButtonLoading: boolean = false;
  EditBusinessInformation: boolean = false;
  customStylesValidated: boolean = false;
  InvoiceDetailsData!: InvoiceDetailsModel;
  IsAdmin: boolean = false;
  TodaysDate = new Date();
  InvoiceIDFromURL: any;
  FromURL: boolean = false;

  BaseURL: string = '';
  placement = ToasterPlacement.TopEnd;
  @ViewChild(ToasterComponent) toaster!: ToasterComponent;
  UserData: any;
  ngOnInit(): void {

    

    this.UserData = JSON.parse(localStorage.getItem('UserInfo') as string );

    this.route.paramMap.subscribe((params) => {
      this.InvoiceIDFromURL = params.get('id')!;
    });
    
    let encodedCode = encodeURIComponent(this.InvoiceIDFromURL);
    
    this.InvoiceIDFromURL = encodedCode;
    console.log("Chat gpt new vr "+this.InvoiceIDFromURL);
    const fullUrl = window.location.href;
    const baseUrl = fullUrl.substring(0, fullUrl.indexOf('#') + 2);
    this.BaseURL = baseUrl;

    if (this.InvoiceIDFromURL !== 'null') {

      console.log("ayaaa "+this.InvoiceIDFromURL);

      this.FromURL = true;

      this.InvoicedetailService.GetInvoiceDetailsById(
        this.InvoiceIDFromURL
      ).subscribe((res: any) => {

        console.log('🚀 > Invoice from url code > res:', res);

        if (res.apiStatus.isSuccess) {

        
          this.InvoicedetailService.selectedInvoiceDataUpdate(res.data);
          // this.InvoiceDetailsData = res.data;
          console.log('🚀 > ).subscribe > res.data:', res.data);

          if(res.data.o_IsBillToClient == true){

          this.getUserExtraInfobyUserId(this.InvoiceDetailsData.user_Id);
          this.getUserBillingInfo(this.InvoiceDetailsData.user_Id, this.InvoiceDetailsData.partner_Id);
          }
          else
          {
            
            this.getUserExtraInfobyUserId(res.data.user_Id);
            
          }
        }
      })
        
    }
    if (
      JSON.parse(localStorage.getItem('UserInfo') as string)?.userType_Id == 3
    ) {
      this.IsAdmin = true;
    }

    this.InvoicedetailService.selectedInvoiceData.subscribe((data) => {
      this.InvoiceDetailsData = data;
    });

    this.getUserExtraInfobyUserId(this.InvoiceDetailsData.user_Id);
    if (this.FromURL) {
      this.ToastService.toastState.subscribe((options) => {
        this.toaster.addToast(AppToastComponent, { ...options });
      });
    }
    
    if(this.InvoiceIDFromURL == 'null'){
      console.log(" from portal par aya hai ayaaa ");
        this.fromportal = true;
       this.getUserBillingInfo(this.InvoiceDetailsData.user_Id, this.InvoiceDetailsData.partner_Id);
    }
}

  goBack() {
    window.history.back();
  }

  getUserBillingInfo(id: any, partnerId: any) {
    this.UsersService.getUserBilling2Info(id, partnerId).subscribe((res: any) => {
      console.log('🚀 > this.UsersService.getUserBillingInfo > res:', res);
      this.UsersService.BusinessInfoData = res.data;

      this.payNowForm.patchValue({

        firstNamebilling: res.data.legalName || '',
        addressLine1: res.data.streetAddr || '',
        state: res.data.state || '',
        city: res.data.city || '',
        zipCode: res.data.zipCode || '',
        country: res.data.country || '',

      });

      this.payNowForm.controls['firstNamebilling'].disable();
      this.payNowForm.controls['addressLine1'].disable();
      this.payNowForm.controls['state'].disable();
      this.payNowForm.controls['city'].disable();
      this.payNowForm.controls['zipCode'].disable();
      this.payNowForm.controls['country'].disable();
    });
  }

  getUserExtraInfobyUserId(id: any) {
    this.UsersService.getUserExtraInfoByUserId(id).subscribe((res: any) => {
    
      console.log('🚀 > this.UsersService.getUserExtraInfoByUserId > res:', res);
      this.InvoiceDetailsData.partnerExtraInfo = res.data;

      this.payNowForm.patchValue({

        firstNamebilling: res.data.o_CompanyName || '',
        addressLine1: res.data.addr_Street || '',
        state: res.data.addr_State || '',
        city: res.data.addr_City || '',
        zipCode: res.data.addr_ZipCode || '',
        country: res.data.addr_Country || '',

      });

      this.payNowForm.controls['firstNamebilling'].disable();
      this.payNowForm.controls['addressLine1'].disable();
      this.payNowForm.controls['state'].disable();
      this.payNowForm.controls['city'].disable();
      this.payNowForm.controls['zipCode'].disable();
      this.payNowForm.controls['country'].disable();

    
    });
  }

  public visibleMarkAsPaidModal = false;

  toggleMarkAsPaidModal() {
    if (this.visibleMarkAsPaidModal) {
      this.InvoicedetailService.MarkAsPaidData = new MarkAsPaidModal();
      this.Message = '';
    }
    this.visibleMarkAsPaidModal = !this.visibleMarkAsPaidModal;
  }
  public visiblePayNowModal = false;

  togglePayNowModal() {
    if (!this.visiblePayNowModal) {
      if (!this.payNowForm.get('firstNamebilling')?.value) {
        this.payNowForm.patchValue({
          firstNamebilling: this.InvoiceDetailsData.partnerExtraInfo.companyName,
        });
      }

      // if (!this.payNowForm.get('addressLine1')?.value) {
      //   this.payNowForm.patchValue({
      //     addressLine1: this.InvoiceDetailsData.partnerExtraInfo?.addr_Street,
      //     addressLine2: this.InvoiceDetailsData.partnerExtraInfo?.addr_City,
      //     state: this.InvoiceDetailsData.partnerExtraInfo?.addr_State,
      //     city: this.InvoiceDetailsData.partnerExtraInfo?.addr_City,
      //     zipCode: this.InvoiceDetailsData.partnerExtraInfo?.addr_ZipCode,
      //     country: this.InvoiceDetailsData.partnerExtraInfo?.addr_Country,
      //   });
      // }
    }
    // this.payNowForm.markAllAsTouched();
    this.visiblePayNowModal = !this.visiblePayNowModal;
  }

  // detectCardType() {
  //   const cardNumber = this.payNowForm.get('cardNumber')?.value;

  //   if (cardNumber.startsWith('4')) {
  //     this.cardType = 'Visa';
  //     this.cardTypeIcon = 'assets/icons/visa.png';
  //   } else if (cardNumber.startsWith('5')) {
  //     this.cardType = 'MasterCard';
  //     this.cardTypeIcon = 'assets/icons/mastercard.png';
  //   } else if (cardNumber.startsWith('6')) {
  //     this.cardType = 'UnionPay';
  //     this.cardTypeIcon = 'assets/icons/unionpay.png';
  //   } else if (cardNumber.startsWith('3')) {
  //     this.cardType = 'American Express';
  //     this.cardTypeIcon = 'assets/icons/amex.png';
  //   } else {
  //     this.cardType = null;
  //     this.cardTypeIcon = null;
  //   }
  // }

  // Handle form submission
  onSubmit(): void {
    if (this.payNowForm.valid) {
      const formData = this.payNowForm.value;
      console.log('Form Submitted:', formData);
      this.ButtonLoading = true;
      const data = {
        cardDetail: {
          cardFirstName: formData.firstName,
          cardNumber: formData.cardNumber,
          cvv: formData.cvv,
          mm: formData.expiryMonth,
          yy: formData.expiryYear,
          cardLastName: formData.lastName,
          billingCycle: this.InvoiceDetailsData.plD_ChargeDuration.toString(),
        },
        invocieNo: this.InvoiceDetailsData.id,
        billingDetail:{
          companyName: this.UsersService.BusinessInfoData.legalName || this.InvoiceDetailsData.partnerExtraInfo.companyName,
          addressLine1: this.payNowForm.get('addressLine1')?.value || formData.addressLine1,
          addressLine2: ".",
          city: this.payNowForm.get('city')?.value || formData.city,
          state: this.payNowForm.get('state')?.value || formData.state,
          country:this.payNowForm.get('country')?.value || formData.country,
          zipCode: this.payNowForm.get('zipCode')?.value || formData.zipCode,
          email: this.UsersService.BusinessInfoData?.emailAddress || this.InvoiceDetailsData.partnerExtraInfo.contactPersonPhone,   
          phone:  this.UsersService.BusinessInfoData?.phoneNo || this.InvoiceDetailsData.partnerExtraInfo.contactPersonPhone,
        }
      };



      console.log('This data for API');
      console.log(data);

      this.InvoicedetailService.CreateRecuring(data).subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.apiStatus.isSuccess) {
                this.togglePayNowModal();
                const options = {
                  title: `Success`,
                  color: 'success',
                  delay: 3000,
                  description: res.apiStatus.message,
                  status: true,
                };
                this.ToastService.showToast(options);
                this.InvoicedetailService.selectedInvoiceDataUpdate(res.data_Invoice);
                this.ngOnInit();
              } else {
                // this.togglePayNowModal();
                const options = {
                  title: `Failed`,
                  color: 'danger',
                  delay: 3000,
                  description: res.apiStatus.message,
                  status: false,
                };
                this.ToastService.showToast(options);
                this.ButtonLoading = false;
              }
              this.ButtonLoading = false;
        },
        error: (error) => {
          console.error(error);
          this.ButtonLoading = false;
          // alert("Error: " + error.error.message);
        },
      });
        
        
      //   (res: any) => {
      //   console.log(res); 
      //   if (res.apiStatus.isSuccess) {
      //     this.togglePayNowModal();
      //     const options = {
      //       title: `Success`,
      //       color: 'success',
      //       delay: 3000,
      //       description: res.apiStatus.message,
      //       status: true,
      //     };
      //     this.ToastService.showToast(options);
      //     this.ngOnInit();
      //   } else {
      //     // this.togglePayNowModal();
      //     const options = {
      //       title: `Failed`,
      //       color: 'danger',
      //       delay: 3000,
      //       description: res.apiStatus.message,
      //       status: false,
      //     };
      //     this.ToastService.showToast(options);
      //     this.ButtonLoading = false;

      //   }

      //   this.InvoicedetailService.selectedInvoiceDataUpdate(res.data_Invoice);
      //   this.ButtonLoading = false;
      // });

        // this.UsersService.BusinessInfoData.legalName =
        // this.payNowForm.get('firstNamebilling')?.value ||  formData.firstNamebilling;
        // this.UsersService.BusinessInfoData.streetAddr = this.payNowForm.get('addressLine1')?.value || formData.addressLine1;
        // this.UsersService.BusinessInfoData.state = this.payNowForm.get('state')?.value || formData.state;
        // this.UsersService.BusinessInfoData.city = this.payNowForm.get('city')?.value || formData.city;
        // this.UsersService.BusinessInfoData.zipCode = this.payNowForm.get('zipCode')?.value || formData.zipCode;
        // this.UsersService.BusinessInfoData.country = this.payNowForm.get('country')?.value || formData.country;
        // this.UsersService.BusinessInfoData.user_Id =
        //   this.InvoiceDetailsData.partner_Id;

        // var formData1 = new FormData();
        // var formDataOutput = '';
        // Object.keys(this.UsersService.BusinessInfoData).forEach((key) => {
        //   const typedKey =
        //     key as keyof typeof this.UsersService.BusinessInfoData;
        //   if (this.UsersService.BusinessInfoData[typedKey] != null) {
        //     formData1.append(
        //       key,
        //       String(this.UsersService.BusinessInfoData[typedKey])
        //     );
        //     formDataOutput +=
        //       '\n' + key + ':' + this.UsersService.BusinessInfoData[typedKey];
        //     console.log(key, this.UsersService.BusinessInfoData[typedKey]);
        //   }
        // });

        // this.UsersService.AddOrUpdateUserBillingInfo(formData1).subscribe({
        //   next: (res: any) => {
        //     console.log(res);
        //   },
        //   error: (error) => {
        //     console.error(error);
        //   },
         
        // });
    } else {
      console.log('Form is invalid');
    }
  }

  Message: any;
  MarkAsPaid(Form: any) {
    // this.customStylesValidated = true;
    if (Form.invalid) {
      if (
        Form.controls.paymentDate.errors?.required &&
        Form.controls.remarks.errors?.required
      ) {
        this.Message = 'Payment Date and Remarks is required';
      } else if (Form.controls.paymentDate.errors?.required) {
        this.Message = 'Payment Date is required';
      } else if (Form.controls.remarks.errors?.required) {
        this.Message = 'Remarks is required';
      }
      setTimeout(() => {
        this.Message = '';
      }, 3000);
      console.log('🚀 > MarkAsPaid > Form:', Form);
      return;
    }
    this.ButtonLoading = true;
    this.InvoicedetailService.MarkAsPaidData.id = this.InvoiceDetailsData.id;
    this.InvoicedetailService.MarkInvoiceAsPaid(
      this.InvoicedetailService.MarkAsPaidData
    ).subscribe({
      next: (res: any) => {
        console.log(
          '🚀 > this.InvoicedetailService.MarkInvoiceAsPaid > res:',
          res
        );
        if (res.apiStatus.isSuccess) {
          this.ButtonLoading = false;
          this.toggleMarkAsPaidModal();
          const options = {
            title: `Success`,
            color: 'success',
            description: res.apiStatus.message,
            status: true,
          };
          this.ToastService.showToast(options);
          this.ngOnInit();
        } else {
          this.ButtonLoading = false;
          const options = {
            title: `Failed`,
            color: 'danger',
            description: res.apiStatus.message,
            status: false,
          };
          this.ToastService.showToast(options);
        }
        console.log(
          '🚀 > this.InvoicedetailService.MarkInvoiceAsPaid > res.data.data:',
          res.data.data
        );
        this.InvoicedetailService.selectedInvoiceDataUpdate(res.data.data);
      },
      error: (error: any) => {
        console.error(error);
        this.ButtonLoading = false;
      },
    });
  }

  ImageData: any;
  async convertToBase64FromPath(path: string): Promise<void> {
    console.log('convertToBase64FromPath');
    const img = new Image();
    img.src = path; 

    await new Promise<void>((resolve) => {
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0);
        const base64String = canvas.toDataURL();
        this.ImageData = base64String;
        resolve();
      };
    });
  }

  DocumentData: any;
  generatePDFForInvoice(item: InvoiceDetailsModel) {
    console.log('PDF GENERATE FOR INVOICE');
    console.log(item);
    this.convertToBase64FromPath('assets/brand/x2xLogo.png').then(() => {
      const image = this.ImageData;

    
      type LineItem =
        | { text: string; bold?: boolean; style?: { alignment: string } }
        | string;

      const LineItems = item.invoice_Details;
      const LinesForPDF: LineItem[][] = [];

      const headers: any[] = [
        // { text: 'Product', bold: true },
        { text: 'Feature', bold: true },
        { text: 'Duration Months', bold: true },
        { text: 'Amount', bold: true, style: { alignment: 'right' } },
      ];

      if (item.extraStores > 0) {
        headers.push({ text: 'Extra Stores Amount', bold: true, style: { alignment: 'right' } });
      }

      headers.push(
        // { text: 'One Time Price', bold: true, style: { alignment: 'right' } },
        { text: 'Net Amount', bold: true, style: { alignment: 'right' } },
       // { text: 'Partner Margin', bold: true, style: { alignment: 'right' } },
        { text: 'Payable Amount', bold: true, style: { alignment: 'right' } },
      );

      LinesForPDF.push(headers);

      LineItems.forEach((element: any) => {
        const row: any[] = [
          // element.productName, // Product
          element.featureName, // Feature
          `${item.plD_Duration} `, // Duration
          // {
          //   text: element.price.toLocaleString('en-US', {
          //     style: 'currency',
          //     currency: 'USD',
          //   }),
          //   style: { alignment: 'right' },
          // }, // Price
         
          
          {
            text: (element.price ).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            }),
            style: { alignment: 'right' },
          }, // Amount
        ];

        if (item.extraStores > 0) {
          row.push({
            text: (element.price_ExtraStore).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            }),
            style: { alignment: 'right' },
          }); // Extra Stores Amount
        }

        row.push(
          // {
          //   text: element.price_OneTime.toLocaleString('en-US', {
          //     style: 'currency',
          //     currency: 'USD',
          //   }),
          //   style: { alignment: 'right' },
          // },  One Time Price
          {
            text: (
              element.price  +
              element.price_OneTime + element.price_ExtraStore
            ).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            }),
            style: { alignment: 'right' },
          }, // Net Amount
          // {
          //   text: (
          //     element.o_IsServiceItem?
          //     (element.price  +
          //       element.price_OneTime + element.price_ExtraStore) *
          //     (item.o_PPkg_ServiceDiscountPercent / 100)
          //     :
          //     (element.price  +
          //       element.price_OneTime + element.price_ExtraStore) *
          //     (item.partnerDiscountRate / 100)


          //   ).toLocaleString('en-US', {
          //     style: 'currency',
          //     currency: 'USD',
          //   }),
          //   style: { alignment: 'right' },
          // },  Partner Margin
          {
            text: (
              element.o_IsServiceItem?
              (element.price ) +
              (element.price_OneTime + element.price_ExtraStore)
              :
              (element.price ) +
              (element.price_OneTime + element.price_ExtraStore) 
            ).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            }),
            style: { alignment: 'right' },
          }, // Payable Amount
        );

        LinesForPDF.push(row);
      });

      const body: any[] = [
        [
          'Invoice No :',
          {
            text: item.docRefNo,
            style: { alignment: 'right' },
          },
        ],
        [
          'Product Name :',
          {
            text: item.invoice_Details[0].productName,
            style: { alignment: 'right' },
          },
        ],
        [
          'Client Name :',
          {
            text: item.o_CompanyName,
            style: { alignment: 'right' },
          },
        ],
        [
          'Plan :',
          {
            text: item.plan?.planName,
            style: { alignment: 'right' },
          },
        ],
        [
          'Invoice Date :',
          {
            text: new Date(item.invoiceDate).toLocaleDateString(),
            style: { alignment: 'right' },
          },
        ],
      ];

      if (item.extraStores > 0) {
        body.push([
          'Extra Stores :',
          {
            text: item.extraStores,
            style: { alignment: 'right' },
          },
        ]);
      }

      body.push([
        'Status :',
        {
          text: item.isPaid
            ? 'Paid'
          
              : {
                  text: 'Click Here to Pay Now',
                  link: this.BaseURL + 'Invoice/' + item.code,
                  style: { color: 'blue' },
                },
          style: { alignment: 'right' },
        },
      ]);

      this.DocumentData = {
        content: [
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                stack: [{ image: image, width: 150, margin: [0, 0, 0, 15] }],
              },
              {
                width: '*',
                text: item.isPaid ? 'PAID' : 'UNPAID',
                style: {
                  alignment: 'center',
                  color: item.isPaid ? 'green' : 'red',
                  fontSize: 20,
                  fontWeight: 'bold',
                  bold: true,
                },
                margin: [0, 25, 0, 0],
              },
            ],
            columnGap: 10,
          },
          {
            style: 'headerData',
            layout: 'noBorders',
            table: {
              widths: ['70%', '30%'],
              body: [
                [
                  { text: 'Bill To:', bold: true, style: { fontSize: 10 } },
                  { text: 'Pay To:', bold: true, style: { fontSize: 10 } },
                ],
                [ this.UsersService.BusinessInfoData.legalName , 'x2x-eCommerce'],
                [
                  this.UsersService.BusinessInfoData?.streetAddr +
                    ', ' +
                    this.UsersService.BusinessInfoData?.city,
                  '2855 Markham Road, Suite 110,',
                ],
                [
                  this.UsersService.BusinessInfoData?.state +
                    ', ' +
                    this.UsersService.BusinessInfoData?.zipCode +
                    ', ' +
                    this.UsersService.BusinessInfoData?.country,
                  'Toronto, ON M1X 0C3, Canada',
                ],
                [this.UsersService.BusinessInfoData?.phoneNo , '1-888-929-3266'],
                [
                  this.UsersService.BusinessInfoData?.emailAddress ,
                  ' info@x2x-ecommerce.com',
                ],
              ],
            },
          },
          {
            style: 'headerData',
            layout: 'noBorders',
            table: {
              widths: ['15%', '20%'],
              body: body,
            },
          },
          {
            style: 'tableExample',
            layout: 'headerLineOnly',
            table: {
              headerRows: 1,
              widths: item.extraStores > 0 
                ? ['*', 'auto', 'auto', 'auto', 'auto', 'auto'] 
                : ['*', 'auto', 'auto', 'auto', 'auto'],
              body: LinesForPDF,
            },
          },
          

          {
            columns: [
              {
                width: '60%',
                text: ' ',
              },
              {
                // auto-sized columns have their widths based on their content
                width: '40%',
                stack: [
                  {
                    style: 'headerData',
                    layout: 'noBorders',
                    table: {
                      widths: ['50%', '50%'],
                      body: [
                        [
                          { text: 'Total Amount', bold: true },
                          {
                            text: item.totalAmount.toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            }),
                            style: { alignment: 'right' },
                            bold: true,
                          },
                        ],
                        [
                          { text: 'Tax Amount', bold: true },
                          {
                            text: item.totalTax.toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            }),
                            style: { alignment: 'right' },
                            bold: true,
                          },
                        ],
                        // [
                        //   { text: 'Partner Margin', bold: true },
                        //   {
                        //     text: item.discountAmount.toLocaleString('en-US', {
                        //       style: 'currency',
                        //       currency: 'USD',
                        //     }),
                        //     style: { alignment: 'right' },
                        //     bold: true,
                        //   },
                        // ],
                        // [
                        //   { text: 'Service Item Margin', bold: true },
                        //   {
                        //     text: item.srvDiscountAmount.toLocaleString('en-US', {
                        //       style: 'currency',
                        //       currency: 'USD',
                        //     }),
                        //     style: { alignment: 'right' },
                        //     bold: true,
                        //   },
                        // ],
                        [
                          { text: 'Payable Amount', bold: true },
                          {
                            text: (item.o_IsBillToClient? item.totalAmount :
                              item.totalAmount - item.discountAmount - item.srvDiscountAmount
                            ).toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            }),
                            style: { alignment: 'right' },
                            bold: true,
                          },
                        ],
                      ],
                    },
                  },
                ],
              },
            ],
            columnGap: 10,
          },

       
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
          },
          tableExample: {
            fontSize: 9,
            margin: [0, 5, 0, 15],
          },
          headerData: {
            fontSize: 9,
            // bold: true,
            margin: [0, 5, 0, 15],
          },
        },
      };
      const pdfFonts = {
        // download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
          bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
          italics:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
          bolditalics:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-MediumItalic.ttf',
        },
      };

      pdfMake.createPdf(this.DocumentData, undefined, pdfFonts).open();
    });
    // console.log(image);
  }



  calculateTotalServiceMargin(): number {
    return this.InvoiceDetailsData.invoice_Details.reduce((total, item) => {
      const serviceMargin = (item.rate * this.InvoiceDetailsData.plD_ChargeDuration + item.price_OneTime) * (this.InvoiceDetailsData.serviceDiscountRate / 100);
      return total + serviceMargin;
    }, 0);
  }
}
